import { useState } from 'react'
import { submitManualTag } from '@/services/scannerService'
import { AppButton } from './AppButton'
import { cn } from '@/utils/cn'

export type ManualTagEntryProps = {
  onSubmit?: (tag: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  /** Denser bar for Engine pages. */
  compact?: boolean
}

export function ManualTagEntry({
  onSubmit,
  placeholder = 'Enter RFID tag ID',
  disabled,
  className,
  compact = false,
}: ManualTagEntryProps) {
  const [value, setValue] = useState('')

  const submit = () => {
    const tag = value.trim()
    if (!tag || disabled) return
    submitManualTag(tag)
    onSubmit?.(tag)
    setValue('')
  }

  return (
    <div className={cn('rfid-mock-bar', compact && 'rfid-mock-bar--compact', className)}>
      <div className="rfid-mock-bar__title">
        {compact ? 'Manual tag' : 'Manual / HID tag entry'}
      </div>
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          autoCapitalize="characters"
          data-no-wedge="true"
          className="rfid-field__control mb-0 font-mono"
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              submit()
            }
          }}
        />
        <AppButton
          onClick={submit}
          disabled={disabled || !value.trim()}
          className="shrink-0 !min-h-0 !rounded-lg !px-3 !py-2.5 !text-xs"
        >
          Add
        </AppButton>
      </div>
    </div>
  )
}
